import { Validateable } from "@models/interfaces";

import { Offer } from "./offer";
import { Field } from "./field";

export class PayoutAccount extends Validateable {
	private payout_provider_id: string = "";
	private provider_id: string = "";
	private offer: Offer = null;
	private fiat_id: string = "";
	private deleted: boolean = false;
	private used: boolean = false;

	private fields: Field[] = [new Field()];

	public getFiatId(): string {
		return this.fiat_id;
	}

	public setFiatId(i: string): void {
		this.fiat_id = i;
	}

	public setProviderId(s: string): void {
		this.payout_provider_id = s;
		this.provider_id = s;
	}

	public getPayoutProviderId(): string {
		return this.payout_provider_id;
	}

	public getProviderId(): string {
		return this.getPayoutProviderId();
	}

	public getOffer(): Offer {
		return this.offer;
	}

	public setOffer(offer: Offer): void {
		this.offer = offer;
	}

	public isDeleted(): boolean {
		return this.deleted;
	}

	public getFields(): Field[] {
		return this.fields.filter((field: Field) => field.getName() !== "");
	}

	public hasFields(fields: Field[]): boolean {
		return fields.every((field: Field) => this.hasField(field.getName()));
	}

	public setFields(fields: Field[]): void {
		this.fields = [];
		fields.forEach((field: Field) => this.fields.push(new Field(field)));
	}

	public hasField(fieldName: string): boolean {
		return this.fields.some((field: Field) => fieldName === field.getName());
	}

	public getField(fieldName: string): Field {
		if (this.hasField(fieldName)) {
			return this.fields.find((field: Field) => field.getName() === fieldName);
		}
		return new Field();
	}

	public addField(field: Field): void {
		if (!this.hasField(field.getName())) {
			this.fields.push(field);
		}
	}

	public isUsed(): boolean {
		return this.used;
	}

	public getNameField(): Field {
		return this.getField("name");
	}

	public getReceiverName(): Field {
		return this.getField("payout_receiver_name");
	}

	public getBankName(): Field {
		return this.getField("bank_name");
	}

	public addFields(providerFields: Field[]): void {
		this.fields = [...this.fields, ...providerFields.filter((field: Field) => !this.hasField(field.getName()))];
	}

	public wasUsed(): void {
		this.used = true;
	}

	public isCard(): boolean {
		return this.getFields().some((field: Field) => field.getName().includes("card"));
	}
}
